import React from 'react'
import { ExpandButtonProps } from './ExpandButton.types'
import styles from './ExpandButton.module.scss'
import { Button } from '../Button'
import { IconCollapse, IconExpand } from 'assets'

const ExpandButtonComponent = (props: ExpandButtonProps) => {
  const {
    isExpanded,
    ...rest
  } = props

  return (
    <Button
      preset='icon'
      {...rest}
    >
      {isExpanded
        ? (
          <IconCollapse
            fill={styles.secondaryContent}
          />
        )
        : (
          <IconExpand
            fill={styles.secondaryContent}
          />
        )}
    </Button>
  )
}

const ExpandButton = ExpandButtonComponent
export { ExpandButton }
